export default {
  mounted(el, binding) {
    binding.value(el)
  },
}